import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from "react";
var SvgChevronDownIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  shapeRendering: "geometricPrecision",
  imageRendering: "optimizeQuality",
  textRendering: "geometricPrecision",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 512 512",
  style: {
    enableBackground: "new 0 0 512 512"
  },
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n		.st0 {\n			fill-rule: evenodd;\n			clip-rule: evenodd;\n			fill: currentColor;\n		}\n	"), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M6.1,175.4l43-43c7.9-7.9,20.7-7.8,28.5,0L256,310.7l178.4-178.3c7.8-7.9,20.7-7.8,28.5,0l43,43 c7.8,7.8,7.8,20.7,0,28.5L313.7,396.2l-0.4,0.4l-43,43c-7.8,7.8-20.7,7.9-28.5,0l-43-43l-0.4-0.4L6.1,204 C-1.8,196.1-1.8,183.3,6.1,175.4z"
}));
var chevron_down_icon_default = SvgChevronDownIcon;
export { chevron_down_icon_default as default };
//# sourceMappingURL=chevron-down-icon.svg.js.map